<template>
    <section class="grid-products-wrap bg-gray clearfix mt-4 mb-4">
        <div class="container">
            <ProductGridSkeleton :quantity="12" :show-more="true" :title-center="true" :show-banner="false" v-if="!isFetchingProducts"></ProductGridSkeleton>
            <div v-else>
                <div class="align-items-center justify-content-center mb-3 d-flex">
                    <span class="title-line left"></span>
                    <h2 class="section-title" v-html="data.title"></h2>
                    <span class="title-line right"></span>
                </div>

                <div class="tab-content grid-products slick-center-items">
                    <div class="grid-products-inner">
                        <ProductCard v-for="product in data.products" :key="product.id" :product="product"/>
                    </div>
                </div>

                <div class="align-items-center justify-content-center mt-3 mb-3 d-flex" v-if="data.products.length < data.count">
                    <button type="button" class="btn btn-more" @click="more">
                    {{ $trans('ecommerce::layout.show_more') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import ProductCard from '../ProductCard.vue';
    import ProductGridSkeleton from './SkeletonLoader/ProductGridSkeleton.vue';

    export default {
        data() {
            return {
                data: {
                    title: '',
                    products: [],
                },
                isFetchingProducts: false,
            };
        },

        components: { ProductCard, ProductGridSkeleton },

        mixins: [],

        props: [],

        computed: {},

        created() {
            this.fetchingProducts();
        },

        methods: {
            more() {
                $.ajax({
                    method: 'GET',
                    url: route('ecommerce.home.suggestion_products.index', { 'skip': this.data.products.length }),
                }).then((response) => {
                   this.data.products = this.data.products.concat(response.products);
                });
            },

            fetchingProducts() {
                $.ajax({
                    method: 'GET',
                    url: route('ecommerce.home.suggestion_products.index', { 'skip': 0 }),
                }).then((response) => {
                    this.data = response;
                    this.isFetchingProducts = true;
                }).catch((xhr) => {
                    this.isFetchingProducts = false;
                    this.$notify(xhr.responseJSON.message);
                });
            },
        },
    };
</script>
